// React and Redux imports
import { useDispatch, useSelector } from 'react-redux';

// Chakra UI components
import {
  Box,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
} from '@chakra-ui/react';

// Actions and constants

import { ReducerStatus } from 'utils/constants';

// Common components
import ResultModal from 'components/common/modals/ResultModal';
import { learningPlanCourseActions } from 'store/modules/learningPlanCourse/learningPlanCourse-slice';
import { deleteLearningPlanCourseAction } from 'store/modules/learningPlanCourse/learningPlanCourse-action';

function DeleteLearningPlanCourseMd() {
  const dispatch = useDispatch();

  // Select delete learning plan state from Redux store
  const deleteLearningPlanCourse = useSelector(
    (state) => state.learningPlanCourse.deleteLearningPlanCourse
  );

  // Toggle the delete learning plan modal
  const handleToggleDeleteModal = (isOpen) => {
    dispatch(
      learningPlanCourseActions.setDeleteLearningPlanCourse({ modal: isOpen })
    );
  };

  // Dispatch action to delete sub-quest learning plan
  const handleDeleteLearningPlanCourse = () => {
    dispatch(
      deleteLearningPlanCourseAction({
        id: deleteLearningPlanCourse.learningPlanId,
        courseId: deleteLearningPlanCourse.courseId,
      })
    );
  };

  // Reset the delete learning plan status
  const handleResultButton = () => {
    dispatch(
      learningPlanCourseActions.setDeleteLearningPlanCourse({
        modal: false,
        courseId: null,
        learningPlanId: null,
        status: ReducerStatus.IDLE,
        error: null,
      })
    );
  };

  return (
    <Box>
      {/* Show ResultModal if the delete operation succeeded or failed */}
      {deleteLearningPlanCourse.status === ReducerStatus.SUCCEEDED ||
      deleteLearningPlanCourse.status === ReducerStatus.FAILED ? (
        <ResultModal
          isOpen={deleteLearningPlanCourse.modal}
          onSubmit={handleResultButton}
          isError={deleteLearningPlanCourse.status === ReducerStatus.FAILED}
          title={
            deleteLearningPlanCourse.status === ReducerStatus.SUCCEEDED
              ? 'Deleted'
              : 'Server Error'
          }
          message={
            deleteLearningPlanCourse.status === ReducerStatus.SUCCEEDED
              ? 'The selected course of this learning plan has been deleted successfully. If you believe this was done in error, please contact the administrator.'
              : deleteLearningPlanCourse.error?.data?.title || 'Server Error'
          }
        />
      ) : (
        // Show confirmation modal for delete operation
        <Modal
          isOpen={deleteLearningPlanCourse.modal}
          onClose={() => handleToggleDeleteModal(false)}
          isCentered
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Confirmation Required</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              Are you sure you want to delete this course? Please note that all
              classes currently using this learning plan will be synchronized
              with these changes.
            </ModalBody>

            <ModalFooter>
              {/* Close button */}
              <Button
                colorScheme="blue"
                mr={3}
                onClick={() => handleToggleDeleteModal(false)}
              >
                Close
              </Button>
              {/* Proceed button */}
              <Button
                variant="outline"
                colorScheme="red"
                isLoading={
                  deleteLearningPlanCourse.status === ReducerStatus.LOADING
                }
                onClick={() => handleDeleteLearningPlanCourse()}
              >
                Proceed
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      )}
    </Box>
  );
}

export default DeleteLearningPlanCourseMd;
